import { AppConfigModel } from "../abstract/app-config.model";

export class Timezone extends AppConfigModel {

    static override CLASS_NAME: string = 'Timezone';
}
